import { ActividadesPlanificadas, InformacionAprobadoresHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE';
import DatePickerBlueColor from 'components/Varios/DatePicker/DatePickerBlueColor';
import React, { useEffect, useState } from 'react'
import { Table, Input, FormGroup, Button } from "reactstrap"
import { DetalleDiaSolicitudManual, InformacionManualHorasExtras, InformacionManualHorasExtrasServer, InformacionManualSolicitudPagoHE } from './TypesIngresoManualSolicHE';
import SelectItem2 from 'components/Varios/SelectNew';
import { ObtenerOpcionesActividades } from 'components/UsuarioGeneral/HorasExtras/SolicitudPagoHE/TablaSolicitudHE';
import { FileInfo, SelectCombo } from 'components/Types/GeneralTypes';
import HoraInput from './HoraInput';
import { EsMayorHora, EsMayorIgualHora, RestarHoras, SumarHoras } from 'functions/TimeFunctions';
import { ParametrosSolicitudHE, TiposHorasExtras } from 'components/UsuarioGeneral/HorasExtras/SolicitudPagoHE/TypesSolicitudPagoHE';
import ModalFileUploadFlexible from 'components/Varios/Modals/ModalFileUploadFlexible';
import { GuardarBorradorSolicitudManual, GuardarSolicitudManual } from './ServicesSolicitudHEManual';
import { PruebaSolucion2 } from 'functions/DatesFunctions';
import { showAlert, showAlertAviso } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras';
import Swal from 'sweetalert2';
import ModalCargando from 'components/Varios/ModalCargando';


type PropsTablaSolicitudManualPagoHE = {
    feriados: string[],
    actividadesPlanificadas: ActividadesPlanificadas[],
    detalleDias: DetalleDiaSolicitudManual[],
    parametros: ParametrosSolicitudHE,
    aprobadoresUnidad: InformacionAprobadoresHEDTO[],
    usuarioidentificacion: string,
    mes: number,
    anio: number,
    unidad: number,
    contratolaboral: number,
    nombretabla: string,
    rows: InformacionManualHorasExtras[],
    onSubirDocumentos: () => Promise<void>
}

const esHoraValida = (hora: string): boolean => {
    //const regexHora = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/;
    const regexHora = new RegExp('^([01]?[0-9]|2[0-3]):([0-5][0-9])$');
    return regexHora.test(hora);
};

function ObtenerHorario(fecha: Date | null, listadoHorarios: DetalleDiaSolicitudManual[], esFeriadoFinSemana: boolean | null, tipo: "entrada" | "salida") {

    if (fecha === null || (esFeriadoFinSemana === null || (esFeriadoFinSemana !== null && esFeriadoFinSemana))) {
        return ""
    }

    const indice: number = listadoHorarios.findIndex((v) => {
        const fechaListado = new Date(v.fecha);
        return fecha.getTime() === fechaListado.getTime();
    })

    if (indice > -1) {
        if (tipo === "entrada") {
            return listadoHorarios[indice].horarioEntrada
        }
        else {
            return listadoHorarios[indice].horarioSalida
        }
    }
    return ""
}


function CalcularHorasManualesSuplyExtr(horadesde: string, horahasta: string, finsemanaferiado: boolean, timeHorasParaConsiderarSuplementaria: string, maxtimesinrecesofds: string) {
    var horasExtras: TiposHorasExtras = {
        horasSuplementarias: "",
        horasExtraordinarias: "",
        totalhoras: ""
    }

    if (horadesde && horahasta) {
        var diferencia: string = RestarHoras(horadesde, horahasta);


        if (finsemanaferiado) {
            if (EsMayorIgualHora(diferencia, maxtimesinrecesofds)) {
                const diferenciaTotal = RestarHoras("00:30", diferencia);

                horasExtras.horasExtraordinarias = diferenciaTotal
            }
            else {
                horasExtras.horasExtraordinarias = diferencia
            }
        }
        else {
            const superaHorasSuplementarias: boolean = EsMayorHora(diferencia, timeHorasParaConsiderarSuplementaria)

            if (superaHorasSuplementarias) {
                horasExtras.horasSuplementarias = timeHorasParaConsiderarSuplementaria;
            }
            else {
                horasExtras.horasSuplementarias = diferencia
            }
        }
    }

    horasExtras.totalhoras = SumarHoras(horasExtras.horasExtraordinarias, horasExtras.horasSuplementarias)
    return horasExtras

}


export default function TablaSolicitudManualPagoHE(props: PropsTablaSolicitudManualPagoHE) {


    const fechaMinima = new Date(props.anio, props.mes, 1, 0, 0, 0, 0);
    const fechaMaxima = new Date(props.anio, props.mes + 1, 0, 0, 0, 0, 0);


    const defaultVacio: InformacionManualHorasExtras = {
        dia: null,
        esFeriadoFinSemana: null,
        esPlanificada: null,
        idActividad: null,
        actividad: "",
        idPlanifActividadPersona: null,
        horarioEntrada: "",
        horarioSalida: "",
        horaExtraDesde: "",
        horaExtraHasta: "",
        horaExtraHastaUsuario: "",
        horaSupl: "",
        horaExtr: "",
        horaEntrada: "",
        horaSalida: "",
        totalHorasExtras: ""
    }


    const [filas, setFilas] = useState<InformacionManualHorasExtras[]>([defaultVacio]);
    const [modalSubirDocumentos, setmodalSubirDocumentos] = useState<boolean>(false)
    const [loadingAccion, setloadingAccion] = useState<boolean>(false)

    useEffect(() => {
        if (props.rows.length > 0) {

            var filas = [...props.rows]

            for (let index = 0; index < filas.length; index++) {
                const element = filas[index];
                element.dia = element.dia !== null ? new Date(element.dia) : element.dia
                element.horarioEntrada = ObtenerHorario(element.dia, props.detalleDias, element.esFeriadoFinSemana, "entrada")
                element.horarioSalida = ObtenerHorario(element.dia, props.detalleDias, element.esFeriadoFinSemana, "salida")
            }

            setFilas(filas)
        }
    }, [props.rows])


    const handleSort = (column: string) => {
        // const isAsc = sortColumn === column && sortDirection === 'asc';
        // setSortColumn(column);
        // setSortDirection(isAsc ? 'desc' : 'asc');
        // setSortToggle(!sortToggle); 
    };


    const handleChange = (index: number, field: string, value: any) => {
        var nuevasFilas = [...filas];
        const maxHorasSuplEnDiaOrdinario = props.parametros.timeHorasParaConsiderarSuplementarias;
        const maxHorasSinReceso = props.parametros.maxTimeSinRecesoFDS;


        if (field === "actividadPlanificadaHE") {

            const opcion: SelectCombo = value;
            nuevasFilas[index]["idPlanifActividadPersona"] = +opcion.value;
            nuevasFilas[index]["actividad"] = opcion.label;

        }
        else if (field === "actividadNoPlanificadaHE") {
            var texto: string = value;
            if (texto) {
                texto = texto.toUpperCase();
            }
            nuevasFilas[index].actividad = texto;
            nuevasFilas[index].idPlanifActividadPersona = null;
        }
        else if (field === "dia") {
            const fechasFeriadosFinSemana = props.feriados.map((v, i) => {
                return new Date(v)
            })

            const fechaElegida: Date = value

            const indice = fechasFeriadosFinSemana.findIndex((v) => { return v.getTime() === fechaElegida.getTime() })
            const esFinSemanaFeriado = indice > -1

            nuevasFilas[index]["esFeriadoFinSemana"] = esFinSemanaFeriado
            nuevasFilas[index]["dia"] = fechaElegida

            nuevasFilas[index]["horaEntrada"] = null
            nuevasFilas[index]["horaSalida"] = null

            nuevasFilas[index]["horaExtraDesde"] = null
            nuevasFilas[index]["horaExtraHasta"] = null

            nuevasFilas[index]["horaSupl"] = null
            nuevasFilas[index]["horaExtr"] = null

            // const valorHoraDesde = nuevasFilas[index].horaExtraDesde;
            // const valorHoraHasta = nuevasFilas[index].horaExtraHasta

            // if (valorHoraDesde !== null && valorHoraHasta && esHoraValida(valorHoraDesde) && esHoraValida(valorHoraHasta)) {
            //     const calculoHoras = CalcularHorasManualesSuplyExtr(valorHoraDesde, valorHoraHasta, esFinSemanaFeriado, maxHorasSuplEnDiaOrdinario, maxHorasSinReceso);
            //     nuevasFilas[index].horaExtr = calculoHoras.horasExtraordinarias;
            //     nuevasFilas[index].horaSupl = calculoHoras.horasSuplementarias;
            // }

        }
        else if (field === "esPlanificadaS") {
            if (value === null) {
                nuevasFilas[index]["esPlanificada"] = null;
            }
            else {
                nuevasFilas[index]["esPlanificada"] = value;
                nuevasFilas[index].actividad = "";
            }



        }
        else if (field === "esPlanificadaN") {
            if (value === null) {
                nuevasFilas[index]["esPlanificada"] = null;
            }
            else {
                nuevasFilas[index]["esPlanificada"] = !value;
                nuevasFilas[index].idPlanifActividadPersona = null;
                nuevasFilas[index].idActividad = null;
                nuevasFilas[index].actividad = "";
            }


        }
        else if (field === "horaExtraDesde") {
            const valorHoraDesde: string = value;
            const valorHoraHasta = nuevasFilas[index].horaExtraHasta
            const esFinSemanaFeriado = nuevasFilas[index].esFeriadoFinSemana

            if (valorHoraHasta != null && valorHoraHasta !== "" && esHoraValida(valorHoraDesde) && esHoraValida(valorHoraHasta) && esFinSemanaFeriado !== null) {
                const calculoHoras = CalcularHorasManualesSuplyExtr(valorHoraDesde, valorHoraHasta, esFinSemanaFeriado, maxHorasSuplEnDiaOrdinario, maxHorasSinReceso);
                nuevasFilas[index].horaExtr = calculoHoras.horasExtraordinarias;
                nuevasFilas[index].horaSupl = calculoHoras.horasSuplementarias;
                nuevasFilas[index].horaExtraDesde = value;
            }
            else if(!esHoraValida(valorHoraDesde)){
                nuevasFilas[index].horaExtr = null;
                nuevasFilas[index].horaSupl = null;
                nuevasFilas[index].horaExtraHasta = null;
                nuevasFilas[index].horaExtraDesde = value;
            }
            else {
                nuevasFilas[index].horaExtraDesde = value;
            }

        }
        else if (field === "horaExtraHasta") {

            const valorHoraDesde = nuevasFilas[index].horaExtraDesde;
            const valorHoraHasta: string = value
            const esFinSemanaFeriado = nuevasFilas[index].esFeriadoFinSemana

            if (valorHoraDesde !== null && valorHoraDesde !== "" && esHoraValida(valorHoraDesde) && esHoraValida(valorHoraHasta) && esFinSemanaFeriado !== null) {
                const calculoHoras = CalcularHorasManualesSuplyExtr(valorHoraDesde, valorHoraHasta, esFinSemanaFeriado, maxHorasSuplEnDiaOrdinario, maxHorasSinReceso);
                nuevasFilas[index].horaExtr = calculoHoras.horasExtraordinarias;
                nuevasFilas[index].horaSupl = calculoHoras.horasSuplementarias;
                nuevasFilas[index].horaExtraHasta = value;
            }
            else if(!esHoraValida(valorHoraHasta)){
                nuevasFilas[index].horaExtr = null;
                nuevasFilas[index].horaSupl = null;
                nuevasFilas[index].horaExtraHasta = value;
            }
            else {
                nuevasFilas[index].horaExtraHasta = value;
            }
        }

        else if (field === "horaSalida") {

            if (value.length === 5) {
                nuevasFilas[index][field] = value
                if (!PuedeIngresarHoraExtra(nuevasFilas[index])) {
                    showAlertAviso("No tiene horas adicionales laboradas. Por favor, verificar")
                    nuevasFilas[index]["horaExtraDesde"] = null
                    nuevasFilas[index]["horaExtraHasta"] = null
                    nuevasFilas[index]["horaSupl"] = null
                    nuevasFilas[index]["horaExtr"] = null
                }

                var horaEntrada = nuevasFilas[index]["horaEntrada"];


                if (horaEntrada && horaEntrada.length === 5 && nuevasFilas[index].esFeriadoFinSemana === true) {
                    nuevasFilas[index]["horaExtraDesde"] = horaEntrada
                    nuevasFilas[index]["horaExtraHasta"] = value
                    const calculoHoras = CalcularHorasManualesSuplyExtr(horaEntrada, value, true, maxHorasSuplEnDiaOrdinario, maxHorasSinReceso);
                    nuevasFilas[index].horaExtr = calculoHoras.horasExtraordinarias;
                    nuevasFilas[index].horaSupl = calculoHoras.horasSuplementarias;
                }


            }
        }
        else {

            nuevasFilas[index][field] = value;

        }
        setFilas(nuevasFilas);
    };


    const agregarFila = () => {
        ;
        setFilas([...filas, defaultVacio]);
    };

    const eliminarFila = (index: number) => {
        var copiaFilas = [...filas];

        const filasfiltradas = copiaFilas.filter((v, i) => { return i !== index })
        setFilas(filasfiltradas);
    };

    const footer = (filas: InformacionManualHorasExtras[]) => {
        var totalHorasSuplementarias: string = "";
        var totalHorasExtraordinarias: string = "";
        var totalHorasExtras: string = "";

        for (let index = 0; index < filas.length; index++) {
            const element = filas[index];

            if (element.horaExtr !== null && element.horaExtr !== "") {
                totalHorasExtraordinarias = SumarHoras(totalHorasExtraordinarias, element.horaExtr);
            }

            if (element.horaSupl !== null && element.horaSupl !== "") {
                totalHorasSuplementarias = SumarHoras(totalHorasSuplementarias, element.horaSupl);
            }

        }

        totalHorasExtras = SumarHoras(totalHorasSuplementarias, totalHorasExtraordinarias);

        return (
            <>
                <tr>
                    <td colSpan={7}>
                    </td>
                    <td colSpan={4} style={{ textAlign: "right" }}>
                        <div> TOTAL HORAS EXTRAS SOLICITADAS:</div>
                    </td>
                    <td style={{ textAlign: "center", border: "1px solid black" }}>{totalHorasSuplementarias}</td>
                    <td style={{ textAlign: "center", border: "1px solid black" }}>{totalHorasExtraordinarias}</td>
                </tr>
                <tr>
                    <td colSpan={11}>
                    </td>
                    <td colSpan={2} style={{ textAlign: "center", border: "1px solid black" }}>{totalHorasExtras}</td>
                </tr>

            </>

        )
    }

    const inputsConfig = [
        {
            id: 'hojaMarcaciones',
            label: 'Subir Hoja Marcaciones',
            placeholder: 'Hoja Marcaciones',
            accept: '.pdf',
        },
        {
            id: 'formularioHE',
            label: 'Subir Formulario de Pago de HE',
            placeholder: 'Formulario HE',
            accept: '.pdf',
        }

    ];

    const handleFilesUpload = async (identificacion: string, diasSolicitud: InformacionManualHorasExtras[], files: FileInfo[], contratolaboral: number, nombretabla: string, informacionAprobador: any) => {

        setloadingAccion(true)

        var datosSolicitudParse: InformacionManualHorasExtrasServer[] = [...diasSolicitud];

        datosSolicitudParse = datosSolicitudParse.filter(ds => ds.dia !== null && ds.horaEntrada !== null && ds.horaSalida !== null && ds.horaExtraDesde !== null && ds.horaExtraHasta !== null );

        datosSolicitudParse = datosSolicitudParse.map((v) => {
            return { ...v, dia: v.dia !== null ? PruebaSolucion2(v.dia) : null }
        })


        const respuestaGuardado = await GuardarSolicitudManual(props.anio, props.mes + 1, props.unidad, identificacion, datosSolicitudParse, files, contratolaboral, nombretabla, informacionAprobador)

        if (respuestaGuardado.status === 200) {
            showAlert("La solicitud ha sido ingresada con éxito", true);
        }
        else {
            var mensaje = respuestaGuardado.errorMessage ?? "Ha ocurrido un evento inesperado durante el ingreso manual de la solicitud"
            showAlert(mensaje, false);
        }
        setloadingAccion(false)
        await props.onSubirDocumentos();



    };


    const ShowAlertMensajeGuardarBorrador = async (identificacion: string, diasSolicitud: InformacionManualHorasExtras[], contratolaboral: number, nombretabla: string, informacionAprobador: any) => {
        const texto = `<div class="custom-modal-content">
                    <p>Esta seguro que desea guardar el borrador de la solicitud: </p>
                    </div>`;

        const result = await Swal.fire({
            html: texto,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });
        if (result.isConfirmed) {
            await HandleGuardarBorrador(identificacion, diasSolicitud, contratolaboral, nombretabla, informacionAprobador);
        } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            console.log("Se negó la acción.");
        } else {
            console.log("El modal fue cerrado sin realizar una acción.");
            return;
        }
    }

    const HandleGuardarBorrador = async (identificacion: string, diasSolicitud: InformacionManualHorasExtras[], contratolaboral: number, nombretabla: string, informacionAprobador: any) => {

        setloadingAccion(true)

        var datosSolicitudParse: InformacionManualHorasExtrasServer[] = [...diasSolicitud];

        datosSolicitudParse = datosSolicitudParse.map((v) => {
            return { ...v, dia: v.dia !== null ? PruebaSolucion2(v.dia) : null }
        })


        const respuestaGuardado = await GuardarBorradorSolicitudManual(props.anio, props.mes + 1, props.unidad, identificacion, datosSolicitudParse, contratolaboral, nombretabla, informacionAprobador)

        if (respuestaGuardado.status === 200) {
            showAlert("La solicitud ha sido guardada con éxito. No olvide subir documentos para completar el ingreso", true);
        }
        else {
            var mensaje = respuestaGuardado.errorMessage ?? "Ha ocurrido un evento inesperado durante el ingreso manual de la solicitud"
            showAlert(mensaje, false);
        }

        setloadingAccion(false)


    };



    function PuedeIngresarHoraExtra(fila: InformacionManualHorasExtras) {
        return !fila.esFeriadoFinSemana ? EsMayorHora((fila.horaSalida ?? ""), ObtenerHorario(fila.dia, props.detalleDias, fila.esFeriadoFinSemana, "salida")) : true
    }

    // function ValidateHoraSalida(fila: InformacionManualHorasExtras) {
    //     return !fila.esFeriadoFinSemana ? EsMayorHora((fila.horaSalida ?? ""), ObtenerHorario(fila.dia, props.detalleDias, fila.esFeriadoFinSemana, "salida")) : true
    // }

    function GetHoraMinima(fila: InformacionManualHorasExtras, tipo: "desde" | "hasta") {

        var resultado: { "minimo": string, "mensajeError": string } = { minimo: "", mensajeError: "" }

        if (fila.esFeriadoFinSemana) {

            if (tipo === "desde") {
                resultado.minimo = fila.horaEntrada ?? ""
                resultado.mensajeError = `La hora adicional debe ser igual o posterior a ${resultado.minimo}`
            }
            else {
                resultado.minimo = fila.horaExtraDesde !== "" && fila.horaExtraDesde !== null ? SumarHoras(fila.horaExtraDesde, "00:01") : ""
                resultado.mensajeError = `La hora adicional debe posterior a ${fila.horaExtraDesde}`

            }

        }
        else {
            if (tipo === "desde") {
                resultado.minimo = ObtenerHorario(fila.dia, props.detalleDias, fila.esFeriadoFinSemana, "salida")
                resultado.mensajeError = `La hora adicional debe ser igual o posterior a ${resultado.minimo}`


            }
            else {
                resultado.minimo = fila.horaExtraDesde !== "" && fila.horaExtraDesde !== null ? SumarHoras(fila.horaExtraDesde, "00:01") : ""
                resultado.mensajeError = `La hora adicional debe ser posterior a ${fila.horaExtraDesde}`
            }
        }

        return resultado;

    }

    function GetHoraMaxima(fila: InformacionManualHorasExtras) {

        var resultado: { "maximo": string, "mensajeError": string } = { maximo: "", mensajeError: "" }


        resultado.maximo = fila.horaSalida ?? ""
        resultado.mensajeError = `La hora adicional no puede ser mayor a ${resultado.maximo}`

        return resultado;

    }



    const ButtonIsDisabled = (filas: InformacionManualHorasExtras[]) => {

        var cantidadFilas = filas.length;
        
        const hayFilasSinFechas = filas.find((v) => v.dia === null) !== undefined;

        const hayFilasConFechasSinDatos = filas.find((v) => v.dia !== null && (v.esPlanificada === null || ((v.horaSupl === "" || v.horaSupl === null) && (v.horaExtr === "" || v.horaExtr === null)) || ((v.horaExtraDesde === "" || v.horaExtraDesde === null) && (v.horaExtraHasta === "" || v.horaExtraHasta === null)))) !== undefined;

        
        

        return (cantidadFilas === 1 && (hayFilasSinFechas || hayFilasConFechasSinDatos)) || (cantidadFilas > 1  && hayFilasConFechasSinDatos);
    }

    return (
        <React.Fragment>
            <Table className="table_solicitud_he_manual" responsive>
                <thead className="cabeceras_tabla_solicitud_pago_he">
                    <tr >
                        <th rowSpan={2} className="" >Día</th>
                        <th rowSpan={2} >
                            <span>Sab.</span> <br />
                            <span>Dom. </span> <br />
                            <span>Fest.</span>

                        </th>
                        <th colSpan={2} >
                            Actividad
                        </th>
                        <th rowSpan={2} className="thActividades">
                            Actividades
                        </th>
                        <th className="thHorasAdicionalesSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horario
                        </th>
                        <th className="thHorasLaboradasSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horas Laboradas
                        </th>
                        <th className="thHorasAdicionalesSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horas Adicionales
                        </th>
                        <th className="thHorasExtrasSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horas Extras
                        </th>
                    </tr>
                    <tr>
                        <th className={"thplanificada"} >P</th>
                        <th className={"thimprevista"} >I</th>
                        <th>H. Entr</th>
                        <th className='thSalida'>H. Sali</th>
                        <th>Entrada</th>
                        <th className='thSalida'>Salida</th>
                        <th>Desde</th>
                        <th className='thHasta'>Hasta</th>
                        <th>Sup.</th>
                        <th className='thHExt'>Ext</th>
                    </tr>
                </thead>
                <tbody className="tbodysolicitudpagohe">
                    {filas.map((fila, index) => (
                        <tr key={index} className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE rowsSolicPagoHe'>
                            <td className="diaSeleccion">
                                <DatePickerBlueColor
                                    value={fila.dia}
                                    disabled={false}
                                    name={"fechaigresomanual " + index}
                                    id={"fechaigresomanual " + index}
                                    onChange={(e) => { handleChange(index, "dia", e) }}
                                    min={fechaMinima}
                                    max={fechaMaxima}
                                    monthdropdown={false}
                                    portalId={"root"}
                                />
                                {/* <input value={fila.dia} onChange={(e) => handleChange(index, "dia", e.target.value)} /> */}

                            </td>
                            <td className="text-center feriadoFinSemana">
                                {fila.esFeriadoFinSemana === null ? "" : fila.esFeriadoFinSemana ? "SI" : "NO"}
                            </td>
                            <td className="tdPlanificada" style={{ textAlign: "center" }}>
                                {

                                    <Input
                                        onClick={() => {
                                            if (fila.esPlanificada) {
                                                handleChange(index, "esPlanificadaS", null,);
                                            }
                                        }}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(index, "esPlanificadaS", e.target.checked)}
                                        className="checkRadioRegimenNroHorasExtras"
                                        type="radio"
                                        checked={fila.esPlanificada === null ? false : fila.esPlanificada}
                                        name={"planificadaS" + index}
                                        id={"idplanificadaS" + index}
                                    />
                                }

                                {/* <input value={fila.planificada} onChange={(e) => handleChange(index, "planificada", e.target.value)} /> */}
                            </td>
                            <td className="tdImprevista" style={{ textAlign: "center" }}>
                                <Input
                                    onClick={() => {
                                        if (!fila.esPlanificada) {
                                            handleChange(index, "esPlanificadaN", null);
                                        }
                                    }}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(index, "esPlanificadaN", e.target.checked)}
                                    className="checkRadioRegimenNroHorasExtras"
                                    type="radio"
                                    checked={fila.esPlanificada === null ? false : !fila.esPlanificada}
                                    name={"planificadaN" + index}
                                    id={"planificadaN" + index}
                                />
                                {/* <input value={fila.imprevista} onChange={(e) => handleChange(index, "imprevista", e.target.value)} /> */}
                            </td>
                            <td className='actividades'>
                                {/* <input value={fila.actividades} onChange={(e) => handleChange(index, "actividades", e.target.value)} /> */}
                                {
                                    fila.esPlanificada === null ?
                                        <div></div>
                                        : fila.esPlanificada === true ?
                                            <SelectItem2
                                                options={ObtenerOpcionesActividades(props.actividadesPlanificadas, props.unidad)}
                                                placeholder=""
                                                name={"actividadPlanificadaHE" + index}
                                                id={"actividadPlanificadaHE" + index}
                                                icon="fa-caret-down"
                                                value={fila.idPlanifActividadPersona ?? 0}
                                                onChange={(value, name, tipo, label) => handleChange(index, "actividadPlanificadaHE", {
                                                    label,
                                                    value
                                                },)}
                                                isSearchable={false}
                                                menuPortalTarget={document.body}
                                            />
                                            :
                                            <FormGroup>
                                                <Input
                                                    id={"actividad" + index}
                                                    name={"actividadName" + index}
                                                    maxLength="200"
                                                    className="inputActividadHE"
                                                    type="textarea"
                                                    placeholder="Máximo 200 caracteres"
                                                    value={fila.actividad ?? ""}
                                                    onChange={(e) => handleChange(index, "actividadNoPlanificadaHE", e.target.value,)}
                                                />
                                                {/* <div className="text-muted text-right">
                                    {informacionDiaJornada.actividad !== null ? informacionDiaJornada.actividad.length: 0}/{200}
                                </div> */}
                                            </FormGroup>



                                }



                            </td>
                            <td className='tdEntrada text-center'>
                                <div>
                                    {ObtenerHorario(fila.dia, props.detalleDias, fila.esFeriadoFinSemana, "entrada")}
                                </div>

                            </td>
                            <td className='tdSalida text-center'>
                                <div>
                                    {ObtenerHorario(fila.dia, props.detalleDias, fila.esFeriadoFinSemana, "salida")}
                                </div>
                            </td>
                            <td className="tdentradasalidainput">
                                <HoraInput
                                    key={"horaEntrada " + index}
                                    value={fila.horaEntrada ?? ""}
                                    onChange={(h) => handleChange(index, "horaEntrada", h)}

                                />
                                {/* <input value={fila.horaExtraDesde} onChange={(e) => handleChange(index, "desde", e.target.value)} /> */}
                            </td>
                            <td className="tdentradasalidainput">
                                <HoraInput
                                    key={"horaSalida " + index}
                                    value={fila.horaSalida ?? ""}
                                    onChange={(h) => handleChange(index, "horaSalida", h)}
                                />
                                {/* <input value={fila.horaExtraHasta} onChange={(e) => handleChange(index, "hasta", e.target.value)} /> */}
                            </td>
                            <td className="tddesdehastamanual">
                                <HoraInput
                                    key={"horaExtraDesde " + index}
                                    value={fila.horaExtraDesde ?? ""}
                                    onChange={(h) => handleChange(index, "horaExtraDesde", h)}
                                    minTime={GetHoraMinima(fila, "desde").minimo} // Hora mínima permitida
                                    errorMessage={GetHoraMinima(fila, "desde").mensajeError} // Opcional
                                    maxTime={GetHoraMaxima(fila).maximo}
                                    maxTimeErrorMessage={GetHoraMaxima(fila).mensajeError}
                                    disabled={!fila.horaSalida || !fila.horaSalida || !PuedeIngresarHoraExtra(fila)}
                                />
                                {/* <input value={fila.horaExtraDesde} onChange={(e) => handleChange(index, "desde", e.target.value)} /> */}
                            </td>
                            <td className="tddesdehastamanual">
                                <HoraInput
                                    key={"horaExtraHasta " + index}
                                    value={fila.horaExtraHasta ?? ""}
                                    onChange={(h) => handleChange(index, "horaExtraHasta", h)}
                                    minTime={GetHoraMinima(fila, "hasta").minimo} // Hora mínima permitida
                                    errorMessage={GetHoraMinima(fila, "hasta").mensajeError} // Opcional
                                    maxTime={GetHoraMaxima(fila).maximo}
                                    maxTimeErrorMessage={GetHoraMaxima(fila).mensajeError}
                                    disabled={!fila.horaEntrada || !fila.horaSalida || !fila.horaExtraDesde || !PuedeIngresarHoraExtra(fila)}
                                />
                                {/* <input value={fila.horaExtraHasta} onChange={(e) => handleChange(index, "hasta", e.target.value)} /> */}
                            </td>
                            <td className="tddesdehastamanual">
                                <HoraInput
                                    key={"inputHorasSupl " + index}
                                    value={fila.horaSupl ?? ""}
                                    onChange={(h) => handleChange(index, "horaSupl", h)}
                                    disabled = {!fila.horaExtraDesde}
                                />
                                {/* <input value={fila.sup} onChange={(e) => handleChange(index, "sup", e.target.value)} /> */}
                            </td>
                            <td className="tddesdehastamanual">
                                <HoraInput
                                    key={"inputHorasExtr " + index}
                                    value={fila.horaExtr ?? ""}
                                    onChange={(h) => handleChange(index, "horaExtr", h)}
                                    disabled = {!fila.horaExtraHasta}
                                />
                                {/* <input value={fila.ext} onChange={(e) => handleChange(index, "ext", e.target.value)} /> */}
                            </td>
                            <td className="tdAccionAgregar">
                                {
                                    filas.length - 1 === index ? <button onClick={agregarFila}>+</button> :
                                        <button onClick={() => { eliminarFila(index) }}>-</button>
                                }

                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot className="tfootersolicitudpagohe">
                    {footer(filas)}
                </tfoot>
            </Table>
            <div className='mr-auto ml-auto'>


                <Button className="button-he-secondary"
                    disabled={ButtonIsDisabled(filas)}
                    onClick={async () => await ShowAlertMensajeGuardarBorrador(props.usuarioidentificacion, filas, props.contratolaboral, props.nombretabla, 0)}
                >
                    GUARDAR BORRADOR
                </Button>

                <Button className="button-he-secondary"
                    disabled={ButtonIsDisabled(filas)}
                    onClick={() => setmodalSubirDocumentos(true)}  >SUBIR DOCUMENTOS PARA INGRESO DE SOLIC.</Button>

            </div>

            <ModalFileUploadFlexible
                isOpen={modalSubirDocumentos}
                description='Por favor, sube los siguientes archivos para continuar:'
                toggle={() => { setmodalSubirDocumentos(!modalSubirDocumentos) }}
                inputsConfig={inputsConfig}
                title='Subir Archivos Requeridos'
                onFilesUpload={async (files, informacionAprobador) => await handleFilesUpload(props.usuarioidentificacion, filas, files, props.contratolaboral, props.nombretabla, informacionAprobador)}
                opcionesDirectivo={props.aprobadoresUnidad}
            />

            <ModalCargando
                show={loadingAccion}
                onClose={() => setloadingAccion(false)}
                size='md'
                textoCargando='Ingresando información'
            />



        </React.Fragment>

    )
}
